import { INotifiedUserRepository } from '../../domain/repositories/INotifiedUser.repository'
import { NotifiedUser } from '../../domain/entities/NotifiedUser'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { NotifiedUserClient } from './ports/NotifiedUserClient.port'
import { CreateAndUpdateNotifiedUserDto } from '../../domain/dtos/CreateAndUpdateNotifiedUser.dto'
import { NotifiedUserSchema } from './schemas/NotifiedUser.schema'

export class NotifiedUserRepositoryApiAdapter implements INotifiedUserRepository {
	private _endpoint = '/v1/usuario'

	constructor(private _httpClient: NotifiedUserClient) {}
	async delete(notifiedUserIds: string[]): Promise<void> {
		const response = await this._httpClient.delete(this._endpoint, {
			params: { id: notifiedUserIds },
			paramsSerializer: {
				indexes: null,
			},
		})

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível excluir usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return
	}
	async getAll(customerId: string): Promise<NotifiedUser[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return response.data.map((data: any) => NotifiedUserSchema.parse(data))
	}

	async create(notifiedUser: CreateAndUpdateNotifiedUserDto): Promise<string> {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}

		const response = await this._httpClient.post(
			this._endpoint,
			JSON.stringify(notifiedUser),
			config,
		)

		if (response.status !== HttpStatusCodeEnum.Created) {
			throw new Error(
				'Não foi possível cadastrar usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return response.data.id
	}

	async update(notifiedUser: CreateAndUpdateNotifiedUserDto): Promise<void> {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}
		const response = await this._httpClient.put(
			`${this._endpoint}`,
			JSON.stringify(notifiedUser),
			config,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível editar usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return
	}
}
